"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCards = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var object_1 = require("../../utils/object");
var guid_1 = require("../../utils/guid");
var parse_json_1 = require("./parse-json");
var removeNullProperties = function (data) { return lodash_1.omitBy(data, lodash_1.isNull); };
var parseCard = function (itemActionData) {
    itemActionData = object_1.keysToCamelCase(itemActionData);
    var type = itemActionData.type, actionId = itemActionData.actionId, clientId = itemActionData.clientId, appearance = itemActionData.appearance, position = itemActionData.position, orientation = itemActionData.orientation;
    var omittedProperties = [
        'actionId',
        'clientId',
        'type',
        'appearance',
        'position',
        'orientation',
        'parentItemId',
        'dateCreated',
        'dateUpdated',
    ];
    var parsedItemAction = tslib_1.__assign({ actionId: actionId, clientId: clientId || guid_1.guid(), type: type, from: appearance.start, to: appearance.start + appearance.duration, position: position,
        orientation: orientation }, lodash_1.omit(itemActionData, omittedProperties));
    return lodash_1.flow(removeNullProperties, parse_json_1.parseJSON)(parsedItemAction);
};
exports.parseCards = function (rawCards) {
    var videoCards = lodash_1.map(rawCards, parseCard);
    return lodash_1.orderBy(videoCards, ['from', 'updatedTimestamp'], ['asc', 'asc']);
};
//# sourceMappingURL=cards.js.map